// The two Bootstrap 3 behaviours still in the markup (data-toggle="tab" and
// data-dismiss="alert"). The views set the open tab server-side with
// Bootstrap's class names (li.active, .tab-pane.in.active), so this keeps
// those names; Assets/css/components/tabs.css styles them.

function showTab(link) {
  const target = document.querySelector(link.getAttribute('href'));

  if (!target) {
    return;
  }

  link.closest('ul')?.querySelectorAll(':scope > li').forEach((item) => {
    item.classList.toggle('active', item.contains(link));
  });
  link.closest('ul')?.querySelectorAll('[data-toggle="tab"]').forEach((other) => {
    other.setAttribute('aria-selected', String(other === link));
  });

  target.parentElement?.querySelectorAll(':scope > .tab-pane').forEach((pane) => {
    pane.classList.toggle('active', pane === target);
    pane.classList.toggle('in', pane === target);
  });

  window.dispatchEvent(new CustomEvent('tab:shown', { detail: { id: target.id, link } }));
}

export function enhanceBootstrapShims() {
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-toggle="tab"]');

    if (tab) {
      event.preventDefault();
      showTab(tab);
      return;
    }

    const dismiss = event.target.closest('[data-dismiss="alert"]');

    if (dismiss) {
      event.preventDefault();
      dismiss.closest('.alert')?.remove();
    }
  });
}
